export { default } from './SkeletonTravelsGuideContainer';
